const getOptions = (options, optionKey) => {
  if (!options || !optionKey) {
    return [];
  }
  return options[optionKey];
};

// eslint-disable-next-line import/prefer-default-export
export const getFilterStructure = (filterOptions) => [
  {
    key: 'year',
    title: 'Contract year',
    type: 'select',
    options: getOptions(filterOptions, 'year')?.sort((a, b) => b.value - a.value),
    value: '',
    operator: 'EQ',
    expanded: true,
    hideClear: true,
  },
  {
    key: 'fedStandardCode',
    title: 'Federal Standard',
    type: 'multiselect',
    options: getOptions(filterOptions, 'fedStandardCode'),
    value: [],
    operator: 'OR',
    expanded: true,
    hideClear: true,
  },
  {
    key: 'userType',
    title: 'User type',
    type: 'multiselect',
    options: getOptions(filterOptions, 'userType'),
    value: [],
    operator: 'OR',
    expanded: true,
    hideClear: true,
  },
  {
    key: 'origin',
    title: 'Origin',
    type: 'multiselect',
    options: getOptions(filterOptions, 'origin'),
    value: [],
    operator: 'OR',
    expanded: true,
    hideClear: true,
  },
];
